 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		82: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"3":"component---src-pages-404-js","4":"component---src-pages-account-configs-page-1-js","5":"component---src-pages-account-configs-page-2-js","6":"component---src-pages-attach-email-js","7":"component---src-pages-auth-2-j-4-js","8":"component---src-pages-chatroom-js","9":"component---src-pages-confirm-purchase-js","10":"component---src-pages-credit-packages-js","11":"component---src-pages-credit-purchase-ok-result-2-js","12":"component---src-pages-credit-purchase-ok-result-js","13":"component---src-pages-credit-purchase-result-2-js","14":"component---src-pages-credit-purchase-result-js","15":"component---src-pages-downloadimage-2-js","16":"component---src-pages-downloadimage-js","17":"component---src-pages-game-support-1-js","18":"component---src-pages-game-support-2-js","19":"component---src-pages-game-support-att-js","20":"component---src-pages-game-support-js","21":"component---src-pages-gotoad-js","22":"component---src-pages-gotoad-return-purchase-js","23":"component---src-pages-gotoad-return-result-js","24":"component---src-pages-gotoadios-js","25":"component---src-pages-index-js","26":"component---src-pages-last-report-js","27":"component---src-pages-login-js","28":"component---src-pages-message-js","29":"component---src-pages-myreportreturnconfirm-js","30":"component---src-pages-myreportreturnsdkcallback-js","31":"component---src-pages-payment-providers-js","32":"component---src-pages-payment-support-addticket-2-js","33":"component---src-pages-payment-support-addticket-js","34":"component---src-pages-payment-support-js","35":"component---src-pages-payment-support-result-js","36":"component---src-pages-react-detect-device-test-js","37":"component---src-pages-reset-password-1-js","38":"component---src-pages-reset-password-2-js","39":"component---src-pages-reset-password-js","40":"component---src-pages-sdk-ad-2-js","41":"component---src-pages-sdk-ad-iframe-js","42":"component---src-pages-sdk-ad-ios-iframe-js","43":"component---src-pages-sdk-ad-ios-js","44":"component---src-pages-sdk-ad-js","45":"component---src-pages-sdk-ad-noodle-bc-2-js","46":"component---src-pages-sdk-ad-noodle-bc-js","47":"component---src-pages-sdk-ad-noodle-entr-2-js","48":"component---src-pages-sdk-ad-noodle-entr-2-only-js","49":"component---src-pages-sdk-ad-noodle-entr-js","50":"component---src-pages-sdk-ad-noodle-entronly-js","51":"component---src-pages-sdk-ad-noodle-fr-2-js","52":"component---src-pages-sdk-ad-noodle-fr-js","53":"component---src-pages-sdk-ad-noodle-j-4-js","54":"component---src-pages-sdk-ad-noodle-js","55":"component---src-pages-sdk-ad-noodle-nu-2-js","56":"component---src-pages-sdk-ad-noodle-nu-js","57":"component---src-pages-sdk-ad-noodle-nw-2-js","58":"component---src-pages-sdk-ad-noodle-nw-js","59":"component---src-pages-sdk-ad-noodle-unionpay-2-js","60":"component---src-pages-sdk-ad-noodle-unionpay-js","61":"component---src-pages-sdk-ad-noodle-vip-2-js","62":"component---src-pages-sdk-ad-noodle-vip-js","63":"component---src-pages-sdk-callback-2-js","64":"component---src-pages-sdk-callback-js","65":"component---src-pages-sdk-teaching-1-js","66":"component---src-pages-sdk-teaching-2-js","67":"component---src-pages-sdk-teaching-3-js","68":"component---src-pages-sdk-teaching-4-js","69":"component---src-pages-sdk-teaching-js","70":"component---src-pages-sdk-teachingsdkcallback-js","71":"component---src-pages-signup-js","72":"component---src-pages-unionpay-page-1-js","73":"component---src-pages-unionpay-page-2-js","74":"component---src-pages-x-recharge-page-0-js","75":"component---src-pages-x-recharge-page-1-js","76":"component---src-pages-x-recharge-page-3-js","77":"component---src-pages-xr-saleing-page-1-js","78":"component---src-pages-xr-saleing-page-2-js","79":"component---src-pages-xr-saleing-page-3-2-js","80":"component---src-pages-xr-saleing-page-3-js","81":"component---src-pages-xr-saleing-page-4-js"}[chunkId]||chunkId) + "-" + {"3":"1324269075596aec166a","4":"f5c97c1fc657bc29313d","5":"52867df3cb49a6a337bb","6":"8e8b830038a24089a4ed","7":"75e5cd185753c02b333e","8":"809b738cbcc648a0fd07","9":"1519b723e90ece4b01d6","10":"f1848498e7b1005b45bd","11":"6ca07dc0fc072c39276a","12":"7a817d38399468f79cb0","13":"102cd7e97bc943c58c39","14":"f2e97825fb210666479d","15":"2eb4eca9a9efdcca5beb","16":"d653a96072a69abd7d42","17":"ee161b8998ae8d92df81","18":"fdd27a2f06c23fdeac15","19":"ec9a6def7513ff836f1f","20":"23c77d3a7f6f3694c625","21":"04e3a24d0271d235a2a2","22":"76ddf58ff4bf34ba6cb8","23":"693f5ba0d75e78e8efed","24":"6a6b401869a3ec03e47c","25":"698bce7ba9ecb34afcbf","26":"c14e1a7b46eabd371516","27":"28838995146c3e229bc8","28":"b669a5e95e51184619b5","29":"bfb88a1e0d00d7285f24","30":"48b8c678226cc75c574d","31":"201d7fb8705cc0399ef9","32":"824cfcc04b442b5eb183","33":"710f05299bff041776c4","34":"ed6f46dd3c1d096facc4","35":"413f821d62c8c8c9d065","36":"071309d1c03f7626fbe2","37":"cc84d562b4b34f1b6ca0","38":"bac06fe04191abed0c20","39":"9f6cd6987ccf9c5f39ae","40":"566a08910979e2f9b2ee","41":"a4a892b5dcf5ff267ad9","42":"4b4c82a385807248692b","43":"a8607ae77d14786ddb2b","44":"f46475ccb1ae93cff27f","45":"d2ab872a6a649db9ab96","46":"6029136d99ae8081db76","47":"6758cc2d572254efeb02","48":"8740ee3e1260e6e115a0","49":"2e20645f5d37df30cdc5","50":"0c3bc28940e83d83fe7e","51":"fbe15c61b0b0d043412d","52":"e4a079d9bfae13800375","53":"c3d925bbdaeef5f7579b","54":"4db7402bc1210c08461f","55":"575ae256bc34eca76547","56":"525d97136852ac5a7709","57":"15bbb7acc77b16216757","58":"ae6ef77259e1dd734953","59":"8d7198a2610113e43277","60":"e65a73b2954a6a680476","61":"6852f21abe8462a15d10","62":"2330aedc126445180b16","63":"093f2873e988d7e57406","64":"af520159cd14f8c611d0","65":"2c87a9d68809e63dc0bb","66":"574e5248a194d5f0850a","67":"270ffb078476b9886a15","68":"3b62a11b01822aedaab7","69":"f2a8469496ca59e780a6","70":"86761268b1f10640efad","71":"3ca7b5d8400e2a6fd098","72":"fa63014880317cfbdb41","73":"05d8d1372cb5b9c889eb","74":"f57385519d73ef7d8dd8","75":"3f7a8f6d57dd546775dd","76":"b3efb829eaae92fdd900","77":"a55024faf2e61fbc58a5","78":"bea1f3d1a24041207b3b","79":"ecc89ced4ff255dbb8cb","80":"927e2601414b5b5f8ea1","81":"0ee3a967f591d779a813"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
